import type { ShapeId } from '../lib/stock-shapes'
import { getAgentUrl } from './agent-url'
import { authHeaders } from './auth-headers'

export interface ShapeSuggestion {
  shapeId: ShapeId
  rationale: string
  fit: 'best' | 'good' | 'wasteful'
}

export interface DrawingImage {
  /** 'application/pdf' | 'image/png' | 'image/jpeg' | ... */
  mimeType: string
  /** base64-encoded file contents (no data: prefix) */
  base64: string
}

/**
 * Calls POST /api/agent/suggest-stock-shape with the extracted geometry and an
 * optional drawing image. Returns ranked stock-shape suggestions from the LLM.
 *
 * Per CLAUDE.md: no silent fallbacks — non-2xx responses throw.
 */
export async function fetchShapeSuggestions(
  geometry: Record<string, unknown>,
  drawingImage?: DrawingImage,
): Promise<{ suggestions: ShapeSuggestion[] }> {
  const res = await fetch(`${await getAgentUrl()}/api/agent/suggest-stock-shape`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...await authHeaders() },
    body: JSON.stringify({ geometry, drawingImage }),
  })
  if (!res.ok) {
    const detail = await res.text().catch(() => res.statusText)
    throw new Error(`Suggest stock shape failed (${res.status}): ${detail}`)
  }
  return res.json() as Promise<{ suggestions: ShapeSuggestion[] }>
}
